import { GetBackgroundStyle } from "@talladega/helpers";
import { IFrameLayout } from "@talladega/types";
import { CmsHeading } from "../CmsHeading";

export const IFrame = ({
  heading,
  subheading,
  iframeSrc,
  background,
  baseDomain,
}: IFrameLayout) => {
  return (
    <div
      id="cms-iframe"
      className="no-scrollbar relative overflow-visible bg-white bg-cover bg-center"
      style={GetBackgroundStyle(background, baseDomain)}
    >
      <div className="mx-auto max-w-page items-center gap-6 px-4 pb-6 pt-10 lg:gap-24 lg:px-5 lg:py-16">
        <div className="items-center justify-start pb-6 text-center">
          {heading && (
            <CmsHeading
              headingLevel={heading.headingGroup?.headingLevel}
              textSize={heading.headingGroup?.textSize}
              text={heading.headingGroup?.text}
              htmlId={heading.headingGroup?.htmlId}
            />
          )}
          {subheading && (
            <div className="mt-4 lg:mt-8">
              <CmsHeading
                headingLevel={subheading.headingGroup?.headingLevel}
                textSize={subheading.headingGroup?.textSize}
                text={subheading.headingGroup?.text}
                htmlId={subheading.headingGroup?.htmlId}
              />
            </div>
          )}
        </div>

        <iframe
          src={iframeSrc}
          className="aspect-[16/9] h-full-wo-header w-full"
          title={`${heading?.headingGroup?.text} IFrame`}
        />
      </div>
    </div>
  );
};

export default {};
